import { persistentMap } from "@nanostores/persistent"

export const $hotAgentsMap = persistentMap<Record<string, string | undefined>>("hot-agents", {})
export const $hotOwnersMap = persistentMap<Record<string, string | undefined>>("hot-owners", {})
